var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgXWalletLogo = function SvgXWalletLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-x-wallet",
    x1: 0.134,
    y1: 0.232,
    x2: 0.586,
    y2: 0.628,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#bc0050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#cd2b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#dc5029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#e96f1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#f2860e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#f99706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fda101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "orange"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-x-wallet-2",
    x1: -0.034,
    y1: 0.996,
    x2: 0.845,
    y2: 0.089,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#bc0050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#a02469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#7b578b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#5a84a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#3eaac3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#27c9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#16e0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#09f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#02fbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fffd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-x-wallet-3",
    x1: 0.067,
    y1: 0.073,
    x2: 1.11,
    y2: 0.99,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef0895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#ec0791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#e50687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#d80476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#c7015f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf0054"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76807",
    "data-name": "Group 76807",
    transform: "translate(-5610 49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12998",
    "data-name": "Rectangle 12998",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(5610 -49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75483",
    "data-name": "Group 75483",
    transform: "translate(5612.371 -43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75475",
    "data-name": "Group 75475",
    transform: "translate(3.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75472",
    "data-name": "Group 75472",
    transform: "translate(8.378 7.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71016",
    "data-name": "Path 71016",
    d: "M284.458,156.7l1.656,1.916,6.78,7.841a.176.176,0,0,0,.134.061h2.542a.4.4,0,0,0,.312-.665l-1.771-2.048-6.152-7.112-1.976-2.284-1.526,1.768A.4.4,0,0,0,284.458,156.7Z",
    transform: "translate(-284.361 -154.406)",
    fill: "url(#linear-gradient-x-wallet)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71017",
    "data-name": "Path 71017",
    d: "M299.63,98.89a.4.4,0,0,1,0-.523l7.775-8.988a.4.4,0,0,0-.313-.665H304.55a.178.178,0,0,0-.134.061l-6.762,7.83Z",
    transform: "translate(-287.652 -88.714)",
    fill: "url(#linear-gradient-x-wallet-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75474",
    "data-name": "Group 75474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75473",
    "data-name": "Group 75473",
    transform: "translate(0 7.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71018",
    "data-name": "Path 71018",
    d: "M227.3,156.7l-1.656,1.916-6.78,7.841a.176.176,0,0,1-.134.061h-2.542a.4.4,0,0,1-.313-.665l1.771-2.048,6.152-7.112,1.976-2.284,1.527,1.768A.4.4,0,0,1,227.3,156.7Z",
    transform: "translate(-215.778 -154.406)",
    fill: "#ef0896"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71019",
    "data-name": "Path 71019",
    d: "M224.867,98.89a.4.4,0,0,0,0-.523l-7.775-8.988a.4.4,0,0,1,.313-.665h2.542a.178.178,0,0,1,.134.061l6.762,7.83Z",
    transform: "translate(-216.845 -88.714)",
    fill: "url(#linear-gradient-x-wallet-3)"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXWalletLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-wallet-logo.05cad70e.svg";
export { ForwardRef as ReactComponent };